import {MicOff} from 'lucide-react'
import React from 'react'

type Props = {
  isMuted: boolean
  compact?: boolean
}

const AiMutedIndicator: React.FC<Props> = ({isMuted, compact = false}) => {
  if (!isMuted) return null

  return (
    <>
      {/* Pulsing dimmed overlay */}
      <div className={`ai-muted-overlay ${compact ? 'compact' : ''}`} />

      {/* Mute icon badge */}
      <div className={`ai-muted-badge ${compact ? 'compact' : ''}`}>
        <MicOff size={compact ? 16 : 20} strokeWidth={2.5} />
      </div>

      {/* Ripple rings hidden */}
      {/* <div className={indicatorClass}>
        <div className='muted-pulse-ring' />
        <div className='muted-pulse-ring delay-1' />
        <div className='muted-pulse-ring delay-2' />
      </div> */}
    </>
  )
}

export default React.memo(AiMutedIndicator)
